import IAction from "../../types/IAction";
import actionTypes from "../actionTypes";
import constants from "../../utils/constants";
import axios from "axios";

const PRODUCTOS_CARGA_MASIVA_BASE_URL = "/api/products";

export const validarProductosCargaMasiva = (formData: FormData): IAction => {
  return {
    type: actionTypes.POST_VALIDAR_PRODUCTOS_CARGA_MASIVA,
    payload: axios.post(
      `${constants.BASE_URL}${PRODUCTOS_CARGA_MASIVA_BASE_URL}/productos-carga-masiva/validate`,
      formData,
      {
        withCredentials: true,
        headers: {}
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};

export const procesarProductosCargaMasiva = (formData: FormData): IAction => {
  return {
    type: actionTypes.POST_PROCESAR_PRODUCTOS_CARGA_MASIVA,
    payload: axios.post(
      `${constants.BASE_URL}${PRODUCTOS_CARGA_MASIVA_BASE_URL}/productos-carga-masiva/process`,
      formData,
      {
        withCredentials: true,
        headers: {}
      }
    ),
    meta: {
      resolver: Promise.resolve
    }
  };
};
